import { areFieldsPristine } from "../FieldValidators";

/**
 * Validates the message classification items
 *
 * @param {object} fields
 */
export const validateMessageClassificationFormValidator = (fields, message) => {
  var _editorState$previewA;
  const fieldErrors = {};
  const {
    conversationState: {
      editorState,
      isClassificationMandatory,
      showClassification
    },
    hasExpertTouched,
    hasAddedDialogue,
    isLastCustomerDialogue,
    hasFlaggedConversationComplete
  } = message;
  const hasExpertTouchedMessage = hasFlaggedConversationComplete || hasAddedDialogue;
  const isFormPristine = areFieldsPristine(fields);
  if (!hasExpertTouchedMessage) {
    return {
      isCancelDisabled: hasExpertTouched,
      isFinishDisabled: isLastCustomerDialogue || true,
      isFormPristine,
      fieldErrors,
      isFormInvalid: hasExpertTouchedMessage,
      hasExpertTouchedMessage
    };
  }
  //below will execute if the expert has touched the message

  if (isFormPristine) {
    return {
      isCancelDisabled: true,
      isFinishDisabled: isLastCustomerDialogue || (showClassification ? isClassificationMandatory : false),
      isFormPristine: true,
      fieldErrors,
      isFormInvalid: false,
      hasExpertTouchedMessage
    };
  }
  const pristineMandatoryFields = [];
  //each action is a Classification
  (_editorState$previewA = editorState.previewActions) === null || _editorState$previewA === void 0 ? void 0 : _editorState$previewA.map(action => {
    if (editorState[action.mandatoryKey]) {
      const field = fields[action.payloadKey];
      if (field.pristine) {
        pristineMandatoryFields.push(field);
      }
      const validationError = action.validateField(field);
      if (validationError) {
        fieldErrors[action.payloadKey] = validationError;
      }
    }
  });
  const noFieldErrors = Object.keys(fieldErrors).length === 0;
  const isFormInvalid = !noFieldErrors || pristineMandatoryFields.length !== 0;
  return {
    fieldErrors,
    isFormInvalid,
    isFormPristine: false,
    isCancelDisabled: hasExpertTouchedMessage,
    isFinishDisabled: isLastCustomerDialogue || isFormInvalid,
    hasExpertTouchedMessage
  };
};